import Velocity from 'velocity-animate'

/**
 *
 */
export const cssClassModifier = {
  methods: {
    cssClassModifier(classBlock, modifiers) {
      const classModifiers = []
      if (typeof modifiers === 'string' && modifiers) {
        modifiers = [modifiers]
      }
      if (modifiers.length) {
        modifiers.map((item) => classModifiers.push(`${classBlock}--${item}`))
      }
      return classModifiers
    },
  },
}

/**
 *
 */
export const refreshPage = {
  methods: {
    refreshPage() {
      const name = this.$route.name
      const params = { ...this.$route.params, locale: this.$i18n.locale }
      this.$router.push({ name, params })
    },
  },
}

/**
 * for transition
 */
export const leave = {
  methods: {
    leave(el, complete) {
      Velocity(el, 'slideUp', { duration: 700, complete })
    },
  },
}

/**
 * for transition
 */
export const enter = {
  methods: {
    enter(el, complete) {
      Velocity(el, 'slideDown', { duration: 700, complete })
    },
  },
}

